import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Direction, DirectionHelper } from "../../../../../shared/resources/DirectionHelper";
import { UiConstants } from "../../../../data/UiConstants";
import { FiArrowDown, FiArrowDownLeft, FiArrowDownRight, FiArrowLeft, FiArrowRight, FiArrowUp, FiArrowUpLeft, FiArrowUpRight } from "react-icons/fi";
import { FaCompressArrowsAlt } from "react-icons/fa";
const Row = styled.div.withConfig({
  displayName: "DirectionSelectionDetail__Row",
  componentId: "sc-15hvqcw-0"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;"]);
const CheckboxContainer = styled.div.withConfig({
  displayName: "DirectionSelectionDetail__CheckboxContainer",
  componentId: "sc-15hvqcw-1"
})(["display:flex;flex-direction:column;border:solid 1px black;flex-shrink:1;flex-grow:0;margin-left:4px;"]);
const HeaderText = styled.div.withConfig({
  displayName: "DirectionSelectionDetail__HeaderText",
  componentId: "sc-15hvqcw-2"
})(["margin-bottom:4px;"]);
const DescriptionText = styled.div.withConfig({
  displayName: "DirectionSelectionDetail__DescriptionText",
  componentId: "sc-15hvqcw-3"
})(["display:flex;margin-left:4px;font-size:small;align-items:center;justify-content:center;"]);
const DirectionButton = styled.div.withConfig({
  displayName: "DirectionSelectionDetail__DirectionButton",
  componentId: "sc-15hvqcw-4"
})(["display:flex;width:20px;height:20px;border:1px solid black;cursor:pointer;align-items:center;justify-content:center;&.selected{background-color:", ";}"], UiConstants.COLOR_SELECTION_HIGHLIGHT);
export const DirectionSelectionDetail = observer(({
  initialDirection,
  onSelectionChange
}) => {
  const {
    t
  } = useTranslation();
  const alignmentDescription = initialDirection == null ? "Center" : DirectionHelper.getName(initialDirection);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HeaderText, null, t("action_editor.node_cut_scene_text_alignment")), /*#__PURE__*/React.createElement(DescriptionText, null, t("action_editor.direction_" + alignmentDescription.toLowerCase())), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(CheckboxContainer, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(DirectionButton, {
    className: initialDirection == Direction.NorthWest ? "selected" : "",
    onClick: event => onSelectionChange(Direction.NorthWest)
  }, initialDirection == Direction.NorthWest && /*#__PURE__*/React.createElement(FiArrowUpLeft, null)), /*#__PURE__*/React.createElement(DirectionButton, {
    className: initialDirection == Direction.North ? "selected" : "",
    onClick: event => onSelectionChange(Direction.North)
  }, initialDirection == Direction.North && /*#__PURE__*/React.createElement(FiArrowUp, null)), /*#__PURE__*/React.createElement(DirectionButton, {
    className: initialDirection == Direction.NorthEast ? "selected" : "",
    onClick: event => onSelectionChange(Direction.NorthEast)
  }, initialDirection == Direction.NorthEast && /*#__PURE__*/React.createElement(FiArrowUpRight, null))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(DirectionButton, {
    className: initialDirection == Direction.West ? "selected" : "",
    onClick: event => onSelectionChange(Direction.West)
  }, initialDirection == Direction.West && /*#__PURE__*/React.createElement(FiArrowLeft, null)), /*#__PURE__*/React.createElement(DirectionButton, {
    className: initialDirection == null ? "selected" : "",
    onClick: event => onSelectionChange(null)
  }, initialDirection == null && /*#__PURE__*/React.createElement(FaCompressArrowsAlt, null)), /*#__PURE__*/React.createElement(DirectionButton, {
    className: initialDirection == Direction.East ? "selected" : "",
    onClick: event => onSelectionChange(Direction.East)
  }, initialDirection == Direction.East && /*#__PURE__*/React.createElement(FiArrowRight, null))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(DirectionButton, {
    className: initialDirection == Direction.SouthWest ? "selected" : "",
    onClick: event => onSelectionChange(Direction.SouthWest)
  }, initialDirection == Direction.SouthWest && /*#__PURE__*/React.createElement(FiArrowDownLeft, null)), /*#__PURE__*/React.createElement(DirectionButton, {
    className: initialDirection == Direction.South ? "selected" : "",
    onClick: event => onSelectionChange(Direction.South)
  }, initialDirection == Direction.South && /*#__PURE__*/React.createElement(FiArrowDown, null)), /*#__PURE__*/React.createElement(DirectionButton, {
    className: initialDirection == Direction.SouthEast ? "selected" : "",
    onClick: event => onSelectionChange(Direction.SouthEast)
  }, initialDirection == Direction.SouthEast && /*#__PURE__*/React.createElement(FiArrowDownRight, null))))));
});